import styled from 'styled-components';
import { P, fs, radius, ease, shadow } from '../theme/tokens';

export const PrimaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 18px;
  border: none;
  border-radius: ${radius.md}px;
  background: ${P.grad};
  color: var(--brand-on-primary, ${P.white});
  font-family: inherit;
  font-size: ${fs.sm}px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ${ease}, opacity 150ms;

  &:hover:not(:disabled) {
    background: ${P.gradHover};
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  svg {
    font-size: 12px;
  }
`;

export const AccentBtn = styled(PrimaryBtn)`
  height: 40px;
  background: ${P.accent};
  color: var(--brand-on-accent, ${P.white});
  box-shadow: ${shadow.sm};

  &:hover:not(:disabled) {
    background: color-mix(in oklch, ${P.accent}, black 8%);
  }
`;

export const GhostBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 16px;
  border: 1px solid ${P.border};
  border-radius: ${radius.md}px;
  background: ${P.white};
  color: ${P.muted};
  font-family: inherit;
  font-size: ${fs.sm}px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 150ms, color 150ms;

  &:hover:not(:disabled) {
    border-color: var(--brand-ink, ${P.navy});
    color: var(--brand-ink, ${P.navyInk});
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  svg {
    font-size: 12px;
  }
`;

export const DangerLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  font-family: inherit;
  font-size: ${fs.sm}px;
  font-weight: 600;
  color: ${P.danger};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const ActionBtn = styled(PrimaryBtn)`
  height: 40px;
  background: ${P.action};
  box-shadow: ${shadow.sm};

  &:hover:not(:disabled) {
    background: ${P.actionHover};
  }
  &:focus-visible {
    outline: 2px solid ${P.navy};
    outline-offset: 2px;
  }
`;
